var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"licenses"},[_c('h1',[_vm._v("Verwendete Software und Lizenzen")]),_c('v-data-table',{staticClass:"elevation-3",attrs:{"headers":_vm.headers,"items":_vm.usedsw,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.sw",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.sw))])]}},{key:"item.liz",fn:function(ref){
var item = ref.item;
return [_c('div',[_c('a',{attrs:{"href":item.lizlink}},[_vm._v(_vm._s(item.liz))])])]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }